import React, {useState, useEffect} from 'react';
import fieldService from '../../../services/field-service';
import SubSection from '../../../libs/react-components-admin/section/sub-section';
import IntegrationScaffold from './integration-scaffold';
import ShopifyCustomerMappings from '../../../libs/react-components-admin/integration/shopify-customer-mappings';
import MetafieldMappings from './metafield-mappings';

const SaveCustomerShopifyIntegration = () => {

  const bodyFn = (form, model, updateModelFn) => {
    const sourceFields = (form.fields || [])
      .filter(f => !fieldService.isStaticFieldType(f.fieldType))
      .map(f => ({id: f.id, name: fieldService.fieldDescription(f), fieldType: f.fieldType}));
    return <>
      <SubSection title="Fields">
        <ShopifyCustomerMappings sourceFields={sourceFields}
                                 initialModel={model.mappings}
                                 onChange={v => updateModelFn('mappings', v)}/>
      </SubSection>
      <SubSection title="Metafields" className="mb-4">
        <MetafieldIntegrations sourceFields={sourceFields}
                               value={model.metafieldIntegrations}
                               onChange={v => updateModelFn('metafieldIntegrations', v)}/>
      </SubSection>
    </>;
  };

  return <IntegrationScaffold title="Integration - Shopify - Save customer"
                              type="save-customer"
                              bodyFn={bodyFn}/>;
};

export default SaveCustomerShopifyIntegration;

const MetafieldIntegrations = ({sourceFields, value, onChange}) => {

  const [model, setModel] = useState(value && value.length > 0 ? value : [null]);
  const [_sourceFields, setSourceFields] = useState(sourceFields);

  useEffect(() => { onChange(model[0] ? model : []); }, [model]);
  useEffect(() => { setSourceFields(sourceFields); }, [sourceFields]);

  return <MetafieldIntegration sourceFields={_sourceFields}
                               value={model[0]}
                               onChange={v => setModel([v])}/>
};

const MetafieldIntegration = ({sourceFields, value, onChange}) => {

  const [model, setModel] = useState(value || {});
  const [_sourceFields, setSourceFields] = useState(sourceFields);

  useEffect(
    () => { onChange(((model.mappings || {}).metafields || []).length > 0 ? model : null); },
    [model]
  );
  useEffect(() => { setSourceFields(sourceFields); }, [sourceFields]);

  return <MetafieldMappings isSubIntegration={true}
                            sourceFields={_sourceFields}
                            initialModel={model.mappings}
                            onChange={v => setModel({...model, mappings: v})}/>;
};
